"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[741],{

/***/ 10741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AI": function() { return /* binding */ getMyWeeklySumamries; },
/* harmony export */   "Af": function() { return /* binding */ DEFAULT_COVER_IMAGE; },
/* harmony export */   "Bq": function() { return /* binding */ fetchMyStoryWaitfree; },
/* harmony export */   "ES": function() { return /* binding */ deleteMyStory; },
/* harmony export */   "Fe": function() { return /* binding */ deleteReadStory; },
/* harmony export */   "GX": function() { return /* binding */ getReadEvent; },
/* harmony export */   "Gp": function() { return /* binding */ getWeeklySumamries; },
/* harmony export */   "H_": function() { return /* binding */ postMyStoryWaitfree; },
/* harmony export */   "JA": function() { return /* binding */ patchMyStory; },
/* harmony export */   "LX": function() { return /* binding */ patchMyStoryAd; },
/* harmony export */   "PS": function() { return /* binding */ fetchMyStories; },
/* harmony export */   "TA": function() { return /* binding */ getPublishChallengeInfo; },
/* harmony export */   "UT": function() { return /* binding */ postMyStoryAd; },
/* harmony export */   "_$": function() { return /* binding */ createAvailableCharacter; },
/* harmony export */   "_e": function() { return /* binding */ fetchReadStories; },
/* harmony export */   "a5": function() { return /* binding */ postClickStoryAdFull; },
/* harmony export */   "dq": function() { return /* binding */ postStoryDonation; },
/* harmony export */   "eb": function() { return /* binding */ postMyStory; },
/* harmony export */   "fL": function() { return /* binding */ postExposeStoryAdFull; },
/* harmony export */   "hA": function() { return /* binding */ fetchMyStoryAds; },
/* harmony export */   "i": function() { return /* binding */ deleteWatchLaterStory; },
/* harmony export */   "j1": function() { return /* binding */ fetchUsersOtherStory; },
/* harmony export */   "kA": function() { return /* binding */ fetchMyStoryWaitfreeDailyHistories; },
/* harmony export */   "lU": function() { return /* binding */ unlikeStory; },
/* harmony export */   "mI": function() { return /* binding */ fetchMyStory; },
/* harmony export */   "nM": function() { return /* binding */ fetchStoryAd; },
/* harmony export */   "nU": function() { return /* binding */ fetchStoriesByTags; },
/* harmony export */   "of": function() { return /* binding */ fetchMyStoryBookingInfo; },
/* harmony export */   "q2": function() { return /* binding */ fetchStoryAdFull; },
/* harmony export */   "qN": function() { return /* binding */ postWatchLaterStory; },
/* harmony export */   "qR": function() { return /* binding */ deleteReadStories; },
/* harmony export */   "rD": function() { return /* binding */ fetchStoryChatRoom; },
/* harmony export */   "rI": function() { return /* binding */ postStoryChatRoom; },
/* harmony export */   "su": function() { return /* binding */ fetchStory; },
/* harmony export */   "t$": function() { return /* binding */ fetchStoryByCategory; },
/* harmony export */   "uw": function() { return /* binding */ fetchUserStories; },
/* harmony export */   "vT": function() { return /* binding */ fetchLikedStories; },
/* harmony export */   "yb": function() { return /* binding */ fetchStoryIknow; },
/* harmony export */   "zA": function() { return /* binding */ fetchMyLatestStory; }
/* harmony export */ });
/* unused harmony exports fetchSearchedReadStories, likeStory, patchMyStoryWaitfree, fetchStoryPurchaseInformation */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39854);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45874);
/* harmony import */ var _chatbot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23082);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




var fetchStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat(storyId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyStories = function() {
    var _ref = _asyncToGenerator(function() {
        var filters, page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    filters = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)(_objectSpreadProps(_objectSpread({}, filters), {
                            page: page,
                            perPage: perPage
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyStories() {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyLatestStory = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/latest/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyLatestStory() {
        return _ref.apply(this, arguments);
    };
}();
var DEFAULT_COVER_IMAGE = {
    key: "efacf33b-4afb-4b30-a5ec-7e65b21cd2f2",
    attachmentFormat: "image",
    attachment: {
        contentType: "image/jpeg",
        url: "https://efinder-cdn.eineblu.me/chatie/chatie_story_cover_images/public-efacf33b-4afb-4b30-a5ec-7e65b21cd2f2.jpg",
        originalFilename: "default_cover.jpg",
        width: 750,
        height: 560
    },
    attachmentType: "ChatieStoryCoverImage"
};
var postMyStory = function() {
    var _ref = _asyncToGenerator(function(story) {
        var title, summary, tags, isFinished, isCommentEnabled, ageGrade, coverImage, category, contestId, payload, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    title = story.title, summary = story.summary, tags = story.tags, isFinished = story.isFinished, isCommentEnabled = story.isCommentEnabled, ageGrade = story.ageGrade, coverImage = story.coverImage, category = story.category, contestId = story.contestId;
                    payload = {
                        title: title,
                        summary: summary,
                        isFinished: isFinished,
                        isCommentEnabled: isCommentEnabled,
                        ageGrade: ageGrade,
                        coverImage: coverImage !== null && coverImage !== void 0 ? coverImage : DEFAULT_COVER_IMAGE,
                        tags: tags.map(function(tag) {
                            return tag.id;
                        }),
                        categoryId: category === null || category === void 0 ? void 0 : category.id,
                        contestId: contestId
                    };
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/my-stories/", payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postMyStory(story) {
        return _ref.apply(this, arguments);
    };
}();
var patchMyStory = function() {
    var _ref = _asyncToGenerator(function(_param) {
        var id, story, title, summary, tags, isFinished, isCommentEnabled, coverImage, category, payload, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = _param.id, story = _objectWithoutProperties(_param, [
                        "id"
                    ]);
                    title = story.title, summary = story.summary, tags = story.tags, isFinished = story.isFinished, isCommentEnabled = story.isCommentEnabled, coverImage = story.coverImage, category = story.category;
                    payload = {
                        title: title,
                        summary: summary,
                        isFinished: isFinished,
                        isCommentEnabled: isCommentEnabled,
                        coverImage: coverImage,
                        tags: tags.map(function(tag) {
                            return tag.id;
                        }),
                        categoryId: category === null || category === void 0 ? void 0 : category.id
                    };
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.patch */ .hi.patch("/my-stories/".concat(id, "/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function patchMyStory(_param) {
        return _ref.apply(this, arguments);
    };
}();
var deleteMyStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api["delete"] */ .hi["delete"]("/my-stories/".concat(storyId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function deleteMyStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoriesByTags = function() {
    var _ref = _asyncToGenerator(function(tagId) {
        var options, page, perPage, _ordering, _type, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1, perPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/tags/".concat(tagId, "/stories/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage,
                            ordering: (_ordering = options.ordering) !== null && _ordering !== void 0 ? _ordering : "weekly_popular",
                            type: (_type = options.type) !== null && _type !== void 0 ? _type : "all"
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoriesByTags(tagId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryByCategory = function() {
    var _ref = _asyncToGenerator(function(categoryId, childCategoryId) {
        var isFinished, ordering, page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    isFinished = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "all", ordering = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "popular", page = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 1, perPage = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/categories/".concat(categoryId, "/stories/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            childCategoryId: childCategoryId,
                            isFinished: isFinished,
                            ordering: ordering,
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoryByCategory(categoryId, childCategoryId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyStoryBookingInfo = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/booking-info/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyStoryBookingInfo(storyId) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * User Stories
 */ var fetchUserStories = function() {
    var _ref = _asyncToGenerator(function(userId) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/users/".concat(userId, "/stories/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchUserStories(userId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUsersOtherStory = function() {
    var _ref = _asyncToGenerator(function(userId, param) {
        var excludeId, page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    excludeId = param.excludeId, page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1, perPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/users/".concat(userId, "/stories/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage,
                            excludeId: excludeId
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchUsersOtherStory(userId, _) {
        return _ref.apply(this, arguments);
    };
}();
var fetchReadStories = function() {
    var _ref = _asyncToGenerator(function(sort) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/users/me/read-stories/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage,
                            sort: sort
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchReadStories(sort) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSearchedReadStories = function() {
    var _ref = _asyncToGenerator(function(payload) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, perPage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/users/me/read-stories/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage,
                            sort: payload.sort,
                            q: payload.q
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchSearchedReadStories(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLikedStories = function() {
    var _ref = _asyncToGenerator(function() {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1, perPage = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/users/me/watch-later-stories/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLikedStories() {
        return _ref.apply(this, arguments);
    };
}();
var likeStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/users/me/watch-later-stories/", {
                            storyId: storyId
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function likeStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var unlikeStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api["delete"] */ .hi["delete"]("/users/me/watch-later-stories/".concat(storyId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function unlikeStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Ad
 */ var fetchStoryAd = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/story-ads/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .StoryAdType.list */ .FS.list
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoryAd() {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryAdFull = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/story-ads/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .StoryAdType.full */ .FS.full,
                            storyId: storyId
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoryAdFull(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var postClickStoryAdFull = function() {
    var _ref = _asyncToGenerator(function(storyAdId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/story-ads/".concat(storyAdId, "/click/"), {
                            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .StoryAdType.full */ .FS.full
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postClickStoryAdFull(storyAdId) {
        return _ref.apply(this, arguments);
    };
}();
var postExposeStoryAdFull = function() {
    var _ref = _asyncToGenerator(function(storyAdId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/story-ads/".concat(storyAdId, "/expose/"), {
                            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .StoryAdType.full */ .FS.full
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postExposeStoryAdFull(storyAdId) {
        return _ref.apply(this, arguments);
    };
}();
var postMyStoryAd = function() {
    var _ref = _asyncToGenerator(function(storyId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/my-stories/".concat(storyId, "/ads/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postMyStoryAd(storyId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyStoryAds = function() {
    var _ref = _asyncToGenerator(function(storyId, status) {
        var page, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/ads/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            status: status,
                            page: page
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyStoryAds(storyId, status) {
        return _ref.apply(this, arguments);
    };
}();
var patchMyStoryAd = function() {
    var _ref = _asyncToGenerator(function(storyId, storyAdId, status) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.patch */ .hi.patch("/my-stories/".concat(storyId, "/ads/").concat(storyAdId, "/"), {
                            status: status
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function patchMyStoryAd(storyId, storyAdId, status) {
        return _ref.apply(this, arguments);
    };
}();
var postWatchLaterStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/users/me/watch-later-stories/", {
                            storyId: storyId
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postWatchLaterStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var deleteWatchLaterStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api["delete"] */ .hi["delete"]("/users/me/watch-later-stories/".concat(storyId, "/"))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return function deleteWatchLaterStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var deleteReadStory = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api["delete"] */ .hi["delete"]("/users/me/read-stories/".concat(storyId, "/"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function deleteReadStory(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var deleteReadStories = function() {
    var _ref = _asyncToGenerator(function(storyIds) {
        return __generator(this, function(_state) {
            return [
                2,
                ___WEBPACK_IMPORTED_MODULE_0__/* .api["delete"] */ .hi["delete"]("/users/me/read-stories/bulk/", {
                    data: {
                        storyIds: storyIds
                    }
                })
            ];
        });
    });
    return function deleteReadStories(storyIds) {
        return _ref.apply(this, arguments);
    };
}();
var postStoryDonation = function() {
    var _ref = _asyncToGenerator(function(storyId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/stories/".concat(storyId, "/donation/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postStoryDonation(storyId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var postMyStoryWaitfree = function() {
    var _ref = _asyncToGenerator(function(storyId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/my-stories/".concat(storyId, "/toggle-waitfree/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postMyStoryWaitfree(storyId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyStoryWaitfree = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/waitfree/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyStoryWaitfree(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyStoryWaitfreeDailyHistories = function() {
    var _ref = _asyncToGenerator(function(storyId, year, month) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/waitfree/daily-histories/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            year: year,
                            month: month
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyStoryWaitfreeDailyHistories(storyId, year, month) {
        return _ref.apply(this, arguments);
    };
}();
var patchMyStoryWaitfree = function() {
    var _ref = _asyncToGenerator(function(storyId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.patch */ .hi.patch("/my-stories/".concat(storyId, "/waitfree/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function patchMyStoryWaitfree(storyId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryPurchaseInformation = function() {
    var _ref = _asyncToGenerator(function(storyId, start, end) {
        var created__gte, created__lte, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    created__gte = start;
                    created__lte = end;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat(storyId, "/purchase-info/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            created__gte: created__gte,
                            created__lte: created__lte
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoryPurchaseInformation(storyId, start, end) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryIknow = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat(storyId, "/iknow-map/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoryIknow(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var getReadEvent = function() {
    var _ref = _asyncToGenerator(function(code) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/read-events/".concat(code, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getReadEvent(code) {
        return _ref.apply(this, arguments);
    };
}();
var getPublishChallengeInfo = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/pub-challenge-info/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getPublishChallengeInfo(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var getMyWeeklySumamries = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/weekly-summaries/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getMyWeeklySumamries(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var getWeeklySumamries = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat(storyId, "/weekly-summaries/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getWeeklySumamries(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var postStoryChatRoom = function() {
    var _ref = _asyncToGenerator(function(payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_3__/* .CHAT_BOT_API.post */ .kq.post("/episode-chat-rooms/", payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postStoryChatRoom(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryChatRoom = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_3__/* .CHAT_BOT_API.get */ .kq.get("/episode-chat-rooms/".concat(id, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.result
                    ];
            }
        });
    });
    return function fetchStoryChatRoom(id) {
        return _ref.apply(this, arguments);
    };
}();
var createAvailableCharacter = function() {
    var _ref = _asyncToGenerator(function(json) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _chatbot__WEBPACK_IMPORTED_MODULE_3__/* .CHAT_BOT_API.post */ .kq.post("/episode-chat-rooms/create-info/", {
                            episode_json: json
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.result
                    ];
            }
        });
    });
    return function createAvailableCharacter(json) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);